'use client';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { CreditMap, ComparisonReport } from './types';
import { mockCreditMapAnterior, mockCreditMapAtual, mockComparisonReport } from './mockData';

interface AppStore {
  mapAnterior: CreditMap | null;
  mapAtual: CreditMap | null;
  report: ComparisonReport | null;
  selectedInstitutionId: string | null;
  setMapAnterior: (map: CreditMap) => void;
  setMapAtual: (map: CreditMap) => void;
  setReport: (report: ComparisonReport) => void;
  setSelectedInstitution: (id: string) => void;
  loadMockData: () => void;
  clearAll: () => void;
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      mapAnterior: null,
      mapAtual: null,
      report: null,
      selectedInstitutionId: null,
      setMapAnterior: (map) => set({ mapAnterior: map }),
      setMapAtual: (map) => set({ mapAtual: map }),
      setReport: (report) => set({ report }),
      setSelectedInstitution: (id) => set({ selectedInstitutionId: id }),
      loadMockData: () => set({
        mapAnterior: mockCreditMapAnterior,
        mapAtual: mockCreditMapAtual,
        report: mockComparisonReport,
      }),
      clearAll: () => set({ mapAnterior: null, mapAtual: null, report: null, selectedInstitutionId: null }),
    }),
    {
      name: 'bportugal-app-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);